//#region IMPORTS
import { ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import { InstoreTemplate } from "../../models/instoreTemplate";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
//#endregion

//#region INTERFACE
interface Props {
  instoreTemplate: InstoreTemplate;
  copyHandler: () => void;
}
//#endregion

export default function InstoreTemplatesTableRowActionCopy({
  instoreTemplate,
  copyHandler,
}: Props) {
  //#region RENDER
  return (
    <Fragment>
      <button
        data-tooltip-content="Copy instore template"
        data-tooltip-variant="info"
        data-tooltip-place="right"
        data-tooltip-id={String(instoreTemplate.id) + "copy"}
        data-tooltip-delay-show={500}
        className="flex items-center gap-4"
      >
        <ClipboardDocumentIcon
          className="w-5 h-5 text-sky-500 hover:text-sky-400"
          onClick={copyHandler}
          type="button"
        />
      </button>
      <Tooltip id={String(instoreTemplate.id) + "copy"} className="font-bold"/>
    </Fragment>
  );
  //#endregion
}
